class ContactUs {
    constructor() {
        this.popup = document.querySelector(".contact-popup");

        if (!this.popup) return;

        this.closeBtn = this.popup.querySelector(".contact-popup-close");

        this.init();
    }

    init() {
        document.body.classList.add("popup-open");

        if (this.closeBtn) {
            this.closeBtn.addEventListener("click", () => {
                this.closePopup();
            });
        }

        // Close when clicking outside popup content
        this.popup.addEventListener("click", (event) => {
            if (event.target === this.popup) {
                this.closePopup();
            }
        });

        // Close on Escape key
        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                this.closePopup();
            }
        });
    }

    closePopup() {
        if (!this.popup) return;

        this.popup.classList.add("is-closing");

        setTimeout(() => {
            this.popup.remove();
            document.body.classList.remove("popup-open");
        }, 250);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new ContactUs();
    
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('contact_posted')) {
        // Remove the parameter from the URL without reloading
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
    }
});